import * as React from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"
import { useLocation } from '@reach/router';
import Link from '../Link'

const LayoutBreadcrumbs = () => {
    const location = useLocation();
    const createLI = (data, index) => {
        return  (
            <li key={index}>
                <Link data={{link : data}}>{data.title}</Link>
            </li>
        )
    }

    const data = useStaticQuery(graphql`
    query breadcrumbQuery {
        allNodeTemplatePages {
        edges {
        node {
        id
        title
        path {
        alias
        }
        relationships {
        field_breadcrumb {
        field_title
        field_breadcrumb_link {
        title
        uri
        }
        }
        }
        }
        }
        }
        }
`)
    let currentPage;
    if(data?.allNodeTemplatePages?.edges && data?.allNodeTemplatePages?.edges.length){
        const loc = location?.pathname.slice(-1) === '/' ? location?.pathname.slice(0, -1) : location?.pathname;
        currentPage = data?.allNodeTemplatePages?.edges?.find(page => page?.node?.path?.alias === loc);
    }
    if(currentPage?.node?.relationships?.field_breadcrumb && currentPage?.node?.relationships?.field_breadcrumb instanceof Array && currentPage?.node?.relationships?.field_breadcrumb?.length > 0){
        return (
            <section className={`breadcrumbs`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <ul>
                                {currentPage?.node?.relationships?.field_breadcrumb[0]?.field_breadcrumb_link?.map((el, index) => {
                                        return createLI(el, index)
                                    })
                                }
                                <li><span>{currentPage?.node?.relationships?.field_breadcrumb[0]?.field_title}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        )
    }else{
        return null;
    }
}

export default LayoutBreadcrumbs